<template>
  <div id="app" ref="app">
    <router-view
      key="router-view"
      :data="data"
      :scrollVal="scrollVal"
      v-if="data && !loading"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      loading: true,
      error: null,
      data: null,
      scrollVal: 0,
      preloadArr: [],
      url: "https://api.pantaloni.online/",
    };
  },
  methods: {
    fetchData: function(url) {
      this.$http.get(url).then(
        (result) => {
          this.data = result.data;
          for (let section in this.data.sections) {
            this.preloadArr.push(this.data.sections[section].logo);
          }
          this.preloadImages(this.preloadArr);
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
    },
    preloadImages: function(srcs) {
      function loadImage(src) {
        return new Promise(function(resolve, reject) {
          let img = new Image();
          img.onload = function() {
            resolve(img);
          };
          img.onerror = img.onabort = function() {
            reject(src);
          };
          img.src = src;
        });
      }
      let promises = [];
      const vm = this;
      for (let i = 0; i < srcs.length; i++) {
        promises.push(loadImage(srcs[i]));
      }
      return Promise.all(promises).then(function() {
        vm.loading = false;
      });
    },
    handleScroll: function() {
      this.scrollVal = window.pageYOffset;
    },
  },
  created() {
    this.fetchData(this.url);
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "MaisonNeue";
  src: url("./assets/MaisonNeue-Demi.woff2") format("woff2"),
    url("./assets/MaisonNeue-Demi.woff") format("woff");
  font-weight: 400;
}
html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  background: #eaeaea;
}
html {
  overflow-y: scroll;
}
::-moz-selection {
  background: none;
}
::selection {
  background: none;
}
#app {
  font-family: "MaisonNeue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #be2239;
  overflow: hidden;
  font-weight: 400;
}
a,
a:hover,
a:visited,
a:active,
a:focus {
  font-weight: 400;
  color: #be2239;
  text-decoration: none;
  border-bottom: 0.125em solid;
  transition: color 200ms ease, border 200ms ease;
  @media (hover: hover) {
    &:hover {
      color: black;
    }
  }
}
img {
  pointer-events: none;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
